import { Rating } from '@/components/rating/rating';

const HALF_PRECISION = 0.5;

export const RankingStarInput = ({
  disabled,
  initialValue,
  onChange,
}: {
  disabled?: boolean;
  initialValue?: number;
  onChange?: (value: number) => void;
}) => {
  return (
    <Rating
      disabled={disabled}
      initialValue={initialValue}
      onChange={onChange}
      precision={HALF_PRECISION}
    />
  );
};
